import { useEffect, useCallback } from 'react'
import EventSender from 'src/Utils/EventSender'
import useAppStack from 'src/App/useAppStack'

type BackClickEvents = {
  backClicked: string
}

export const BackClickEventHandler = () => {
  const { appStack, pop } = useAppStack()

  const onMessageReceived = useCallback((event: any) => {
    try {
      const backEvent: BackClickEvents = JSON.parse(event.data)
      if (backEvent.backClicked === 'true') {
        handleNativeAppBackPress()
      }
    } catch (error) {}
  }, [])

  function handleNativeAppBackPress() {
    if (appStack() > 0) {
      pop()
    } else {
      try {
        const event = {
          handleBackClick: 'true',
        }
        EventSender(JSON.stringify(event))
        document.removeEventListener('message', onMessageReceived)
        window.removeEventListener('message', onMessageReceived)
      } catch (e) {
        //doNothing
      }
    }
  }

  useEffect(() => {
    document.addEventListener('message', onMessageReceived)
    window.addEventListener('message', onMessageReceived)
  }, [onMessageReceived])
}
